'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');

var _components = require('../../components');
var _containers = require('../../containers');

var _contactUs = require('../../redux/modules/contactUs');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var ContactUsModal = function ContactUsModal(props) {return (
    _react2.default.createElement(_components.Modal, {
        className: 'contactUsModal',
        isOpen: props.isContactUsModalOpen,
        onRequestClose: props.hideContactUsModal,
        translate: props.translate,
        isRtl: props.isRtl },

      _react2.default.createElement('div', null,
        _react2.default.createElement(_containers.ContactUsFormContainer, {
          usage: _constants.contactUsUsage.modal,
          hideContactUsModal: props.hideContactUsModal }))));}; // Redux
// Components
// Modules



ContactUsModal.propTypes = {
  translate: _propTypes2.default.func,
  hideContactUsModal: _propTypes2.default.func,
  isContactUsModalOpen: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    isMobile: state.windowDimentions.isMobile,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    isContactUsModalOpen: state.contactUs.isContactUsModalOpen };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, {
  hideContactUsModal: _contactUs.hideContactUsModal })(
ContactUsModal);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ContactUsModal/ContactUsModal.js
// module id = 2931
// module chunks = 0